'use strict';
import React from 'react';
import { getOptimizedImageUrl, getCategorySrcSet, handleImageError } from '@src/utils/getOptimizedImageUrl';

class ServicesHomeComponent extends React.Component {
    renderCategories() {
        var self = this;
        var loadCategories =
            self.props.collapsableCategories === 'true' && self.props.numberOfCategories === 4
                ? 4
                : self.props.numberOfCategories;
        var categoryViews = self.props.categories.map(function (item, index) {
            const mediaUrl = item.Media != null ? item.Media?.[0]?.MediaUrl : '';
            return (
                <div className='my-1 col-12 col-sm-6 col-md-3' key={item.ID}>
                    <a href={'/search?categories=' + item.ID} className='category-box tw-group'>
                        <div className='img-box tw-border tw-border-2 tw-border-solid tw-border-[#d2d2d2] group-hover:tw-border-[#000]'>
                            <img
                                // Compensates for SSR hydration timing: image 404s before React attaches onError.
                                ref={(img) => {
                                    if (img && img.complete && img.naturalWidth === 0 && !img.dataset.fellBack) {
                                        handleImageError({ target: img }, mediaUrl);
                                    }
                                }}
                                className='background-image-holder tw-w-full tw-h-full tw-object-cover'
                                src={getOptimizedImageUrl('category', item.ID, 0, 'thumb') || mediaUrl}
                                srcSet={getCategorySrcSet(item.ID, 0) || undefined}
                                sizes='(max-width: 576px) 100vw, (max-width: 768px) 50vw, 25vw'
                                alt={item.Name}
                                title={item.Name}
                                loading='lazy'
                                decoding='async'
                                width={270}
                                height={160}
                                onError={(e) => handleImageError(e, mediaUrl)}
                            />
                        </div>
                        <h4 className='tw-font-bcaasans-regular tw-font-bold tw-text-[14px] tw-text-[#7b7b7b] tw-text-center tw-inline-block tw-w-full tw-bg-transparent tw-pt-[15px] tw-pb-[15px] tw-mt-0 tw-mb-0 tw-transition-all tw-duration-[700ms] tw-ease-linear group-hover:tw-text-white group-hover:tw-bg-black'>
                            {item.Name}
                        </h4>
                    </a>
                </div>
            );
            // }
        });
        return categoryViews;
    }

    renderToggleViewMore() {
        var self = this;
        if (self.props.collapsableCategories === 'true') {
            if (self.props.numberOfCategories == self.props.categories.length && self.props.categories.length > 4) {
                return (
                    <div className='text-center vew-more-btn'>
                        <div className='more-btn right' id='viewMoreCat' onClick={e => self.props.loadLess()}>
                            View Less
                            <img src='/assets/images/chevron-left.svg' />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className='text-center vew-more-btn'>
                        <div className='more-btn' id='viewMoreCat' onClick={e => self.props.loadMore()}>
                            View More
                            <img src='/assets/images/chevron-left.svg' />
                        </div>
                    </div>
                );
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className='section-title category-titles'>
                    <h3 id='services' className='tw-text-[24px] tw-font-bold tw-text-primary-500'>
                        Categories
                    </h3>
                    <div className='divider'></div>
                </div>
                <div className='section-category-list flex flex-wrap' id='categories'>
                    {this.renderCategories()}
                    {/* {this.renderToggleViewMore()} */}
                </div>
            </React.Fragment>
        );
    }
}

export { ServicesHomeComponent };

export default {
    ServicesHomeComponent
};
